import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const DrawerContent = styled.main`
  flex: 1 1 auto;
  overflow: hidden auto;
  padding: ${spacing.double};
`;
